'use es6';

import useMount from 'ContentEditorUI/hooks/useMount';
import { removePatagoniaSkeleton } from 'ContentEditorUI/lib/layoutDom';
const CleanupLoadingSkeleton = () => {
  useMount(removePatagoniaSkeleton);
  return null;
};
export default CleanupLoadingSkeleton;